import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

interface CurrencyAmountRateProps {
  fromCurrency: string | undefined
  toCurrency: string | undefined
  amount: number | undefined
}

export const useCurrencyAmountRate = (props: CurrencyAmountRateProps) => {
  const apiClient = useApiClient(ClientApiClient)

  const { fromCurrency, toCurrency, amount = 0 } = props
  const isSameCurrency = fromCurrency === toCurrency

  const { data: value, isLoading } = useQuery({
    queryKey: queryKeys.config.currencyRate(fromCurrency, toCurrency),
    queryFn: () => apiClient.currencyConverterFromTo(fromCurrency!, toCurrency!),
    enabled: !!fromCurrency && !!toCurrency && !isSameCurrency,
  })

  return {
    amount: (value?.rate || 0) * amount,
    rate: value?.rate,
    currency: value?.baseCurrency,
    isLoading,
  }
}
